import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import icon from 'components/assets/img/icons/ios/add-homescreen.svg'
import $ from 'jquery';
import isMobileDevice from 'components/common/helpers/isMobileDevice';
import T from 'components/common/translations/Translate';
import CookieHelper from 'components/common/helpers/CookieHelper';

const cookieName = "a2hsShowed";

class IosPrompt extends React.Component {

  constructor(props) {
    super(props);
    this.deferredPrompt = null;
    this.state = { hasMounted: false };
  }

  componentDidMount() {
    this.setState({ hasMounted: true })

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      if (!this.isIos()) {
        window.setTimeout(() => this.tryShowPrompts(), 1000);
      }
    });
    if (this.isIos()) {
      this.tryShowPrompts();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isLogged && this.props.isLogged) {
      this.tryShowPrompts();
    }
  }

  setCookie() {
    CookieHelper.setCookie(cookieName, "1", { value: "60", duration: "minutes" });
  }

  isValidCookie() {
    var cookie = CookieHelper.readCookie(cookieName);
    if (cookie) {
      return false;
    } else {
      return true;
    }
  }

  isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  isInStandaloneMode = () => {
    if (window.navigator) {
      return window.navigator.standalone;
    } else {
      return false;
    }
  }

  tryShowPrompts() {
    const { isLogged } = this.props;
    const noStandaloneMode = !this.isInStandaloneMode();
    //is mobile devise only
    if (isMobileDevice()) {
      //iphone prompt
      if (this.isIos()) {
        if (noStandaloneMode && this.isValidCookie() && isLogged) {
          window.setTimeout(() => {
            $("#ios-prompt").fadeIn("slow");
            this.setCookie();
          },
            2000
          );
        }
      } else {
        //android prompt
        if (noStandaloneMode && this.deferredPrompt && this.isValidCookie() && isLogged) {
          this.deferredPrompt.prompt();
          this.setCookie();
        }
      }
    }

  }

  handleClickClose = (event) => {
    $("#ios-prompt").hide();
  }

  render() {
    if (!this.state.hasMounted) {
      return null;
    }

    return (
      <div id="ios-prompt" style={{ display: 'none' }}>
        <div
          className="ios-prompt__close"
          onClick={this.handleClickClose}
        >
          &times;
        </div>
        <p>
          <T>content.iosPromptPart1</T>{' '}
          <img src={icon} />
          <T>content.iosPromptPart2</T>
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  }
}

export default connect(mapStateToProps)(IosPrompt);
